import React from 'react';
import PropTypes from 'prop-types';
import styles from './Radio.module.css';

const Radio = ({ checked, label, value, id, onChange, name, style }) => {
  return (
    <label htmlFor={id || name} className={styles.radio} style={style}>
      <input
        type="radio"
        name={name}
        checked={checked}
        value={value}
        onChange={onChange}
        id={id}
      />
      <span className={styles.radioInner}>
        <span />
      </span>

      {label}
    </label>
  );
};

Radio.propTypes = {
  checked: PropTypes.bool.isRequired,
  label: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  style: PropTypes.shape({}),
};

Radio.defaultProps = {
  style: {},
};

export default Radio;
